import styled from 'styled-components';

const StyledButton = styled.button`
  height: 2.4rem;
  color: var(--primary900);
  border: 1px solid var(--primary300);
  border-radius: 4px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  padding: 0 8px;
  outline: none;
  background: #fff;
  overflow: hidden;
`;

export default StyledButton;
